import useLenis from "@/hooks/useLenis";
import { BookingProvider } from "@/components/booking/BookingContext";
import BookingModal from "@/components/booking/BookingModal";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import BookConsult from "@/components/landing/BookConsult";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  useLenis();
  return (
    <BookingProvider>
      <div className="App font-body">
        <div className="grain-overlay" />
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <Manifesto />
          <Services />
          <Pricing />
          <Testimonials />
          <BookConsult />
          <Contact />
        </main>
        <Footer />
        <BookingModal />
      </div>
    </BookingProvider>
  );
}
